import styled from 'styled-components'

import { helpers } from 'styles'

export const Header = styled.div`
	position: sticky;
	top: -40px;
	z-index: 2;
	background-color: ${helpers.color.background};
	padding-bottom: 4px;
`
